import $ from 'jquery';

export function resetLabel() {
    $('#activeFilterLabel span').text('');
    $('#activeFilterLabel').removeClass('show');
}

export default () => {

    const myOffcanvas = document.getElementById('offcanvasWithBothOptions');
    if (myOffcanvas) {
        myOffcanvas.addEventListener('hidden.bs.offcanvas', event => {
            resetLabel();
            if (!$('.filter-selected').hasClass('filter-all')) {
                var filterSelected = $('.filter-selected span').text();
                $('#activeFilterLabel span').text(filterSelected);
                $('#activeFilterLabel').addClass('show');
            }
        })
    }

    if ($('.filter-selected').hasClass('filter-all')) {
        resetLabel();
    }
}


// WEBPACK FOOTER //
// ../views/partials/hamburger/hamburger.js